import React from 'react'

function ReceiptPaymentsIndex() {
  return (
    <div>ReceiptPaymentsIndex</div>
  )
}

export default ReceiptPaymentsIndex